var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "braces") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "braces"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,29a3,3,0,0,1-3,3H26a3,3,0,0,1-3-3V27H7.86a15,15,0,0,0,2.56,4.52,21,21,0,0,1,4.23,9.22c.82,4,1.83,8.89,2.53,12.28a5,5,0,0,0,9.75.17l2.16-8.82a3,3,0,0,1,5.82,0l2.16,8.82A5,5,0,0,0,46.82,53c.7-3.39,1.71-8.32,2.53-12.28a21,21,0,0,1,4.23-9.22A15,15,0,0,0,56.14,27H41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,23H57a15.41,15.41,0,0,0,0-2.35A15,15,0,0,0,37.14,7.81a15.62,15.62,0,0,1-10.28,0A15,15,0,0,0,7.06,20.65,14.21,14.21,0,0,0,7,23H5a1,1,0,0,0,0,2H23V23a3,3,0,0,1,3-3H38a3,3,0,0,1,3,3v2H59a1,1,0,0,0,0-2ZM32,16a24.28,24.28,0,0,1-11.52-3.15,1,1,0,1,1,1-1.7A22.8,22.8,0,0,0,32,14a22.69,22.69,0,0,0,10.48-2.85,1,1,0,1,1,1,1.7A24.28,24.28,0,0,1,32,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,23a1,1,0,0,0-1,1v1H27a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V27h4v1a1,1,0,0,0,2,0V27h1a1,1,0,0,0,0-2H36V24a1,1,0,0,0-2,0v1H30V24A1,1,0,0,0,29,23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrace);
export default __webpack_public_path__ + "static/media/brace.52180b8790fd7472d944c1c6aa104b87.svg";
export { ForwardRef as ReactComponent };